// extracted by mini-css-extract-plugin
module.exports = {"buttonAddResponsiblePerson":"responsibleperson_buttonAddResponsiblePerson__22COQ","containing":"responsibleperson_containing__2qZd0","tabs":"responsibleperson_tabs__15Qu3"};